import { useTranslation } from 'react-i18next'
import { Box, Stack, Typography, useTheme } from '@mui/material'
import { Home } from '@mui/icons-material'
import BeachAccessIcon from '@mui/icons-material/BeachAccess'
import WorklogCarousel from './carousel/WorklogCarousel'
import CostCarousel from './carousel/CostCarousel'
import CustomImportCarousel from './carousel/CustomImportCarousel'
import VacationCarousel from './carousel/VacationCarousel'

const WorklogViewInfo = () => {
  const { t } = useTranslation()
  const theme = useTheme()

  return (
    <Stack sx={{ pt: 6, overflowX: 'hidden' }} gap={1.5}>
      <Typography variant="h4" component="h1" color={'text.highEmphasis'}>
        {t('components.infoSidebar.schedule.title')}
      </Typography>

      <Typography variant="h5" component="h2" color={'text.highEmphasis'}>
        {t('components.infoSidebar.worklog.elements')}
      </Typography>

      <Box sx={{ color: theme.palette.grey[800], display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Home sx={{ width: 32, height: 32, color: theme.palette.primary.main }} />
          <Typography color={'text.mediumEmphasis'}>{t('components.infoSidebar.worklog.components.remote')}</Typography>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <BeachAccessIcon sx={{ width: 32, height: 32, color: 'text.highEmphasis' }} />
          <Typography color={'text.mediumEmphasis'}>
            {t('components.infoSidebar.worklog.components.vacation')}
          </Typography>
        </Box>
      </Box>

      <Stack>
        <WorklogCarousel />
        <VacationCarousel />
        <CostCarousel />
        <CustomImportCarousel />
      </Stack>
    </Stack>
  )
}

export default WorklogViewInfo
